// Load Styles
import '../scss/main-crolow.scss';

// Load Bootstrap init
import { initBootstrap } from "./bootstrap.js";
import $ from 'jquery'
import 'slick-carousel'
import '../scss/crolow/js/lightbox.js';
import '../scss/crolow/js/site.js';
import '../scss/crolow/js/cookies.js';

//import './utilities/CrolowForms.js';
import { Tooltip, Toast, Popover } from 'bootstrap';

// Your app code
console.log(`Hello ${process.env.HELLO}`);
